export default __webpack_public_path__ + "static/media/egg1.1b1976d9.jpg";